import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "../Header/Header1";
import Footer from "../Footer/footer";
import Sidebar from "../SideBar/SideBar";

import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  InputAdornment,
  Modal,
  Radio,
  RadioGroup,
  FormLabel,
  FormControlLabel,
  Select,
  MenuItem,
  FormControl,
  Grid,
  Button,
  Typography,
  Tabs,
  Tab,
} from "@mui/material";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import PropTypes from "prop-types";
import "./staking.scss";
import usdt from "../../Img/coins/usdt.png";
import coins from "../../Img/coins/coin.svg";
import nodata from "../../Img/newnodta.gif";
import whatsapp from "../../Img/whatsapp.svg";
import telegram1 from "../../Img/telegram1.svg";
import linkedin1 from "../../Img/linkedin1.svg";
import facebook1 from "../../Img/facebook1.svg";
import instagram1 from "../../Img/instagram1.svg";
import x1 from "../../Img/x1.svg";
// import Dreamster-Exchange from "../../Img/Dreamster-Exchange.svg";
import { CircularProgress } from "@mui/material";
import { PieChart } from "@mui/x-charts/PieChart";
import { useDrawingArea } from "@mui/x-charts/hooks";
import { styled } from "@mui/material/styles";
import { toast, ToastContainer } from "react-toastify";
import { WhatsApp } from "@mui/icons-material";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const data = [
  { value: 50, label: "Initial Amount ", color: "#CCCCCC" },
  { value: 150, label: "Returns", color: "#566FFF" },
];

const size = {
  width: 400,
  height: 200,
};

const StyledText = styled("text")(({ theme }) => ({
  fill: theme.palette.text.primary,
  textAnchor: "middle",
  dominantBaseline: "central",
  fontSize: 20,
  fontWeight: 500,
}));

function PieCenterLabel({ children }) {
  const { width, height, left, top } = useDrawingArea();
  return (
    <StyledText x={left + width / 2} y={top + height / 2}>
      {children}
    </StyledText>
  );
}

export default function Stakeflexible() {
  const [value, setValue] = useState(0);
  const [activeTab, setActiveTab] = useState(0);
  const [activeTab1, setActiveTab1] = useState(1);

  const [hideZero, setHideZero] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(5); // Rows per page

  const [coin, setCoin] = useState("sc");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const deposits = [
    {
      date: "14:25 PM",
      // coin: <div className="display-1" ><img src={Dreamster-Exchange} alt="img" /><span>Dreamster-Exchange</span></div>,
      amount: "35.15",
      voucher: "Dreamster-ExUW0K3NI5",
      txid: "5635863563",
      LockPeriod: "Feb 14th 2025",
      status: "Active",
    },
    {
      date: "14:25 PM",
      // coin: <div className="display-1" ><img src={Dreamster-Exchange} alt="img" /><span>Dreamster-Exchange</span></div>,
      amount: "35.15",
      voucher: "Dreamster-ExUW0K3NI5",
      txid: "5635863563",
      LockPeriod: "Feb 14th 2025",
      status: "Active",
    },
    {
      date: "14:25 PM",
      // coin: <div className="display-1" ><img src={Dreamster-Exchange} alt="img" /><span>Dreamster-Exchange</span></div>,
      amount: "35.15",
      voucher: "Dreamster-ExUW0K3NI5",
      txid: "5635863563",
      LockPeriod: "Feb 14th 2025",
      status: "Active",
    },
    {
      date: "14:25 PM",
      // coin: <div className="display-1" ><img src={Dreamster-Exchange} alt="img" /><span>Dreamster-Exchange</span></div>,
      amount: "35.15",
      voucher: "Dreamster-ExUW0K3NI5",
      txid: "5635863563",
      LockPeriod: "Feb 14th 2025",
      status: "Active",
    },
    {
      date: "14:25 PM",
      // coin: <div className="display-1" ><img src={Dreamster-Exchange} alt="img" /><span>Dreamster-Exchange</span></div>,
      amount: "35.15",
      voucher: "Dreamster-ExUW0K3NI5",
      txid: "5635863563",
      LockPeriod: "Feb 14th 2025",
      status: "Active",
    },
    {
      date: "14:25 PM",
      // coin: <div className="display-1" ><img src={Dreamster-Exchange} alt="img" /><span>Dreamster-Exchange</span></div>,
      amount: "35.15",
      voucher: "Dreamster-ExUW0K3NI5",
      txid: "5635863563",
      LockPeriod: "Feb 14th 2025",
      status: "Active",
    },
  ];
  const filteredData = deposits.filter((row) => {
    const matchesSearch = row.date
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    const hasBalance = hideZero ? row.date > 0 : true;
    return matchesSearch && hasBalance;
  });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const [coin1, setCoin1] = useState("all");
  const handleChangeCoin1 = (event) => {
    setCoin1(event.target.value);
  };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [open1, setOpen1] = React.useState(false);
  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => setOpen1(false);

  const [openearn, setopenearn] = React.useState(false);
  const handleopenearn = () => setopenearn(true);
  const handleCloseearn = () => setopenearn(false);

  const [openrefferal, setopenrefferal] = React.useState(false);
  const handleOpenrefferal = () => setopenrefferal(true);
  const handleCloserefferal = () => setopenrefferal(false);

  const [copy, setcopy] = useState("Dreamster-Ex4932409");
  const handleCopy = () => {
    navigator.clipboard.writeText(copy).then(() => {
      return toast.success("Text Copied");
    });
  };

  const [selectedValue, setSelectedValue] = useState("Earned"); // Default value

  const handleRadioChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const handleButtonClick = () => {
    if (selectedValue === "Earned") {
      handleopenearn();
    } else if (selectedValue === "Referral") {
      handleOpenrefferal();
    }
  };

  return (
    <>
      <div className="custom_tabs menu-responsive">
        <div className="tab-headers mb-20">
          <button
            className={`tab-button ${activeTab === 0 ? "active" : ""}`}
            onClick={() => setActiveTab(0)}
          >
            Stake 1
          </button>
          <button
            className={`tab-button ${activeTab === 1 ? "active" : ""}`}
            onClick={() => setActiveTab(1)}
          >
            Stake 2
          </button>
        </div>
        <div className="tab-content">
          {activeTab === 0 && (
            <>
              <div className="box_bdr">
                <div className="display-2 mb-20">
                  <div className="grey_txt">Stake Start Date</div>
                  <div>16-Oct-2024 03:49 am</div>
                </div>
                <div className="display-2">
                  <div className="grey_txt">State Maturity Date</div>
                  <div>14-Feb-2025 03:49 am</div>
                </div>
              </div>
            </>
          )}
          {activeTab === 1 && (
            <>
              <div className="box_bdr">
                <div className="display-2 mb-20">
                  <div className="grey_txt">Stake Start Date</div>
                  <div>16-Oct-2024 03:49 am</div>
                </div>
                <div className="display-2">
                  <div className="grey_txt">State Maturity Date</div>
                  <div>14-Feb-2025 03:49 am</div>
                </div>
              </div>
            </>
          )}
          {activeTab === 2 && (
            <>
              <div className="box_bdr">
                <div className="display-2 mb-20">
                  <div className="grey_txt">Stake Start Date</div>
                  <div>16-Oct-2024 03:49 am</div>
                </div>
                <div className="display-2">
                  <div className="grey_txt">State Maturity Date</div>
                  <div>14-Feb-2025 03:49 am</div>
                </div>
              </div>
            </>
          )}
        </div>
        <div className="box_bdr mt-20">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={6} xl={7}>
              <div className="reward_det">
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <div className="box mb-20">
                      <h6>Inital Staked Coin</h6>
                      <h5>
                        {" "}
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
                            fill="#566FFF"
                          />
                          <path
                            d="M13.1916 16.1164C13.4393 16.1164 13.64 16.016 13.64 15.8922C13.64 15.7684 13.4393 15.668 13.1916 15.668C12.9439 15.668 12.7432 15.7684 12.7432 15.8922C12.7432 16.016 12.9439 16.1164 13.1916 16.1164Z"
                            fill="#009245"
                          />
                          <path
                            d="M23.2757 24.1457C22.8111 24.0901 22.5887 24.0811 22.4954 24.0703C22.386 24.0578 22.2066 24.0416 22.0954 24.0327C21.1106 23.9573 19.1949 23.7564 17.7223 23.5484C16.6263 23.3941 14.5008 23.0049 12.5008 21.5358C11.8568 21.0623 11.2828 20.508 10.8434 19.8354C14.4272 22.2712 18.3824 22.6318 22.542 21.9053C21.7635 21.8049 20.9833 21.7152 20.2048 21.6111C18.1115 21.3331 16.1044 20.7789 14.3035 19.6345C13.0694 18.8506 11.986 17.9053 11.3851 16.5224C11.2864 16.2946 11.2254 16.0506 11.1483 15.8156C12.6514 17.1125 14.2496 18.169 16.0685 18.8775C17.8837 19.586 19.7546 19.9053 21.7062 19.717C21.0586 19.4282 20.3967 19.1932 19.7438 18.9385C17.9357 18.2282 16.212 17.3708 14.8452 15.943C14.3949 15.473 13.9806 14.9654 13.699 14.2551C16.4236 16.282 19.8461 17.7026 21.3797 17.4551L21.2703 17.1627C21.2057 16.9905 21.134 16.8201 21.0532 16.6533C20.3609 15.2291 19.3277 14.0901 18.0774 13.1286C17.4945 12.6802 16.9026 12.2354 16.3806 11.7206C15.7958 11.1448 15.7994 10.5116 16.4254 9.99679C16.9026 9.60397 17.4748 9.27392 18.0577 9.07303C18.8828 8.78783 19.7564 8.64792 20.6263 8.44343C20.2819 7.82998 19.7653 7.35105 19.0694 7.20038C18.3537 7.04612 17.5949 6.94209 16.8721 7.00845C15.9949 7.08917 15.1124 7.07661 14.2371 6.97796C11.7133 6.69096 9.93933 7.94119 9.29718 10.3968C9.02274 11.4479 8.95996 12.5152 9.01736 13.5968C9.02633 13.7672 8.94561 14.0201 8.81826 14.1098C7.4622 15.0694 7.08731 16.4219 7.32229 17.9663C7.37431 18.3125 7.4927 19.1591 8.03081 20.1636C9.01915 22.0111 10.6138 22.9618 11.2577 23.3349C15.9232 26.0416 22.9725 24.325 23.2721 24.1493C23.2792 24.1493 23.2775 24.1457 23.2757 24.1457ZM13.4012 8.65509C13.6416 8.65509 13.8371 8.75195 13.8371 8.87392C13.8371 8.9941 13.6416 9.09276 13.4012 9.09276C13.1609 9.09276 12.9653 8.9959 12.9653 8.87392C12.9653 8.75195 13.1609 8.65509 13.4012 8.65509Z"
                            fill="white"
                          />
                        </svg>{" "}
                        2700.05
                      </h5>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <div className="box mb-20">
                      <h6>Earned Rewards</h6>
                      <h5>
                        {" "}
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
                            fill="#566FFF"
                          />
                          <path
                            d="M13.1916 16.1164C13.4393 16.1164 13.64 16.016 13.64 15.8922C13.64 15.7684 13.4393 15.668 13.1916 15.668C12.9439 15.668 12.7432 15.7684 12.7432 15.8922C12.7432 16.016 12.9439 16.1164 13.1916 16.1164Z"
                            fill="#009245"
                          />
                          <path
                            d="M23.2757 24.1457C22.8111 24.0901 22.5887 24.0811 22.4954 24.0703C22.386 24.0578 22.2066 24.0416 22.0954 24.0327C21.1106 23.9573 19.1949 23.7564 17.7223 23.5484C16.6263 23.3941 14.5008 23.0049 12.5008 21.5358C11.8568 21.0623 11.2828 20.508 10.8434 19.8354C14.4272 22.2712 18.3824 22.6318 22.542 21.9053C21.7635 21.8049 20.9833 21.7152 20.2048 21.6111C18.1115 21.3331 16.1044 20.7789 14.3035 19.6345C13.0694 18.8506 11.986 17.9053 11.3851 16.5224C11.2864 16.2946 11.2254 16.0506 11.1483 15.8156C12.6514 17.1125 14.2496 18.169 16.0685 18.8775C17.8837 19.586 19.7546 19.9053 21.7062 19.717C21.0586 19.4282 20.3967 19.1932 19.7438 18.9385C17.9357 18.2282 16.212 17.3708 14.8452 15.943C14.3949 15.473 13.9806 14.9654 13.699 14.2551C16.4236 16.282 19.8461 17.7026 21.3797 17.4551L21.2703 17.1627C21.2057 16.9905 21.134 16.8201 21.0532 16.6533C20.3609 15.2291 19.3277 14.0901 18.0774 13.1286C17.4945 12.6802 16.9026 12.2354 16.3806 11.7206C15.7958 11.1448 15.7994 10.5116 16.4254 9.99679C16.9026 9.60397 17.4748 9.27392 18.0577 9.07303C18.8828 8.78783 19.7564 8.64792 20.6263 8.44343C20.2819 7.82998 19.7653 7.35105 19.0694 7.20038C18.3537 7.04612 17.5949 6.94209 16.8721 7.00845C15.9949 7.08917 15.1124 7.07661 14.2371 6.97796C11.7133 6.69096 9.93933 7.94119 9.29718 10.3968C9.02274 11.4479 8.95996 12.5152 9.01736 13.5968C9.02633 13.7672 8.94561 14.0201 8.81826 14.1098C7.4622 15.0694 7.08731 16.4219 7.32229 17.9663C7.37431 18.3125 7.4927 19.1591 8.03081 20.1636C9.01915 22.0111 10.6138 22.9618 11.2577 23.3349C15.9232 26.0416 22.9725 24.325 23.2721 24.1493C23.2792 24.1493 23.2775 24.1457 23.2757 24.1457ZM13.4012 8.65509C13.6416 8.65509 13.8371 8.75195 13.8371 8.87392C13.8371 8.9941 13.6416 9.09276 13.4012 9.09276C13.1609 9.09276 12.9653 8.9959 12.9653 8.87392C12.9653 8.75195 13.1609 8.65509 13.4012 8.65509Z"
                            fill="white"
                          />
                        </svg>{" "}
                        4056.81
                      </h5>
                    </div>
                  </Grid>
                </Grid>
                <div className="box">
                  <div className="display-2 flex-wrap">
                    <p>Initial Staked Coin Value (USDT)</p>
                    <h6>50</h6>
                  </div>
                  <div className="display-2 flex-wrap">
                    <p>Flexible Rate</p>
                    <h6 className="green">1%</h6>
                  </div>
                  <div className="display-2 flex-wrap">
                    <p>Staked Days</p>
                    <h6>23</h6>
                  </div>
                  <div className="display-2 flex-wrap">
                    <p>Claimed Rewards (USDT)</p>
                    <h6>0.9</h6>
                  </div>
                </div>
                <div className="display-1 mt-20 flex-wrap">
                  <Button
                    onClick={handleOpen}
                    className="org_btn radius"
                    style={{
                      width: "200px",
                      padding: "10px 20px",
                      fontSize: "14px",
                    }}
                  >
                    Claim
                  </Button>
                  <Button
                    onClick={handleOpen1}
                    className="grey_btn  radius"
                    style={{
                      width: "200px",
                      padding: "10px 20px",
                      textTransform: "capitalize",
                      fontWeight: "600",
                    }}
                  >
                    Redeem
                  </Button>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={6} xl={5}>
              <div className="stake_right">
                <h6>Total Earnings</h6>
                <h5>4878</h5>
                <div className="chart_stake chart_stake_chg">
                  <PieChart series={[{ data, innerRadius: 80 }]} {...size}>
                    <PieCenterLabel>Dreamster-Exchange</PieCenterLabel>
                  </PieChart>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
        <div className="mt-30">
          <div className="display-2 flex-wrap">
            <div className="st_flx">
              <div
                className={`${activeTab1 === 1 ? "active" : ""}`}
                onClick={() => setActiveTab1(1)}
              >
                Staking History
              </div>
              <div
                className={`${activeTab1 === 2 ? "active" : ""}`}
                onClick={() => setActiveTab1(2)}
              >
                Claimed History
              </div>
            </div>
            {/* <div className="display-1 flex-wrap">
              <div className="custom_select">
                <FormControl fullWidth>
                  <Select
                    fullWidth
                    value={coin1}
                    onChange={handleChangeCoin1}
                    sx={{
                      // "& .MuiInputBase-formControl": { borderRadius: "5px" },
                      "& .MuiInputBase-input": {
                        padding: "7px 11px ",
                        minWidth: "140px",
                      },
                      // "& fieldset": { border: "1px solid #d3d1d1 !important" },
                    }}
                  >
                    <MenuItem value="all">All</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <Button
                style={{
                  minWidth: "145px",
                  padding: "8px 20px",
                  fontSize: "15px",
                  fontWeight: "600",
                  borderRadius: "5px",
                  border: "1px solid var(--border-clr)",
                  textTransform: "capitalize",
                  whiteSpace: "nowrap",
                }}
                className="bdr_btn"
              >
                Claim All
              </Button>
            </div> */}
          </div>
          {activeTab1 === 1 && (
            <>
              <TableContainer
                sx={{
                  margin: "20px 0",
                  borderRadius: "5px",
                  border: "1px solid var(--border-clr)",
                }}
              >
                <Table
                  sx={{ minWidth: 650 }}
                  aria-label="simple table"
                  className="deposit-table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 400 }}>
                        Date & Time
                      </TableCell>
                      <TableCell sx={{ fontWeight: 400 }}>Coin</TableCell>
                      <TableCell sx={{ fontWeight: 400 }}>Amount</TableCell>
                      <TableCell sx={{ fontWeight: 400 }}>Voucher</TableCell>
                      <TableCell sx={{ fontWeight: 400 }}>TxID</TableCell>
                      <TableCell sx={{ fontWeight: 400 }}>
                        Lock Period
                      </TableCell>
                      <TableCell sx={{ fontWeight: 400 }}>Status</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {deposits.length > 0 ? (
                      paginatedData.map((row) => (
                        <TableRow className="tr_row">
                          <TableCell> {row.date} </TableCell>
                          <TableCell>{row.coin}</TableCell>
                          <TableCell>{row.amount}</TableCell>
                          <TableCell>{row.voucher}</TableCell>
                          <TableCell>{row.txid}</TableCell>
                          <TableCell>{row.LockPeriod}</TableCell>
                          <TableCell
                            className={
                              row.status === "Active" ? "green_txt" : ""
                            }
                          >
                            {row.status}
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow className="tr_row text-center">
                        <TableCell align="center" colSpan={7}>
                          <img src={nodata} alt="nodata" />
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 15]}
                  component="div"
                  count={filteredData.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableContainer>
            </>
          )}
          {activeTab1 === 2 && (
            <>
              <TableContainer
                sx={{
                  margin: "20px 0",
                  borderRadius: "5px",
                  border: "1px solid var(--border-clr)",
                }}
              >
                <Table
                  sx={{ minWidth: 650 }}
                  aria-label="simple table"
                  className="deposit-table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 400 }}>
                        Date & Time
                      </TableCell>
                      <TableCell sx={{ fontWeight: 400 }}>Coin</TableCell>
                      <TableCell sx={{ fontWeight: 400 }}>Amount</TableCell>
                      <TableCell sx={{ fontWeight: 400 }}>Voucher</TableCell>
                      <TableCell sx={{ fontWeight: 400 }}>TxID</TableCell>
                      <TableCell sx={{ fontWeight: 400 }}>
                        Lock Period
                      </TableCell>
                      <TableCell sx={{ fontWeight: 400 }}>Status</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {deposits.length > 0 ? (
                      paginatedData.map((row) => (
                        <TableRow className="tr_row">
                          <TableCell> {row.date} </TableCell>
                          <TableCell>{row.coin}</TableCell>
                          <TableCell>{row.amount}</TableCell>
                          <TableCell>{row.voucher}</TableCell>
                          <TableCell>{row.txid}</TableCell>
                          <TableCell>{row.LockPeriod}</TableCell>
                          <TableCell
                            className={
                              row.status === "Active" ? "green_txt" : ""
                            }
                          >
                            {row.status}
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow className="tr_row text-center">
                        <TableCell align="center" colSpan={7}>
                          <img src={nodata} alt="nodata" />
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 15]}
                  component="div"
                  count={filteredData.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableContainer>
            </>
          )}
        </div>
      </div>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box class="boxstyle">
          <Typography id="modal-modal-title" variant="h6" component="h2">
            <div className="otp_flx">
              <span className="otp">Claim Your Rewards </span>
              <svg
                onClick={handleClose}
                className="cursor-pointer fill_dark_to_white"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_37_40168)">
                  <path
                    d="M18.75 5.25L5.25 18.75"
                    stroke="black"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M18.75 18.75L5.25 5.25"
                    stroke="black"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_37_40168">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </Typography>
          <br />
          <div className="cus_radio">
            <FormControl fullWidth>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                // defaultValue="Earned"
                name="radio-buttons-group"
                value={selectedValue} // Bind to state
                onChange={handleRadioChange}
              >
                <FormControlLabel
                  value="Earned"
                  control={<Radio />}
                  label="Earned Rewards"
                />
                <FormControlLabel
                  value="Referral"
                  control={<Radio />}
                  label="Referral Rewards"
                />
              </RadioGroup>
            </FormControl>
          </div>
          <div className="display-3">
            <Button
              onClick={handleButtonClick}
              className="org_btn radius"
              style={{ width: "200px", padding: "10px 20px", fontSize: "14px" }}
            >
              Claim
            </Button>
          </div>
        </Box>
      </Modal>

      <Modal
        open={open1}
        onClose={handleClose1}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box class="boxstyle">
          <Typography id="modal-modal-title" variant="h6" component="h2">
            <div className="otp_flx">
              <span className="otp">MSR Code </span>
              <svg
                onClick={handleClose1}
                className="cursor-pointer fill_dark_to_white"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_37_40168)">
                  <path
                    d="M18.75 5.25L5.25 18.75"
                    stroke="black"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M18.75 18.75L5.25 5.25"
                    stroke="black"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_37_40168">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </Typography>
          <br />

          <div className="input_box">
            <TextField
              fullWidth
              value={copy}
              sx={{
                borderRadius: "5px",
                "& .MuiInputBase-formControl": {
                  borderRadius: "5px",
                  backgroundColor: "#fafafa",
                },
                "& .MuiInputBase-input": {
                  padding: "11px  0 11px 20px",
                  border: "0",
                },
                "& fieldset": { border: "0px solid #d3d1d1 !important" },
                "& .MuiInputBase-input::placeholder": {
                  color: "black",
                  fontSize: "15px",
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment
                    position="end"
                    onClick={handleCopy}
                    className="cusrsor-pointer"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M15.1647 2.27214V3.53027H17.1488H17.1504V3.53353C17.777 3.53516 18.3451 3.78906 18.7552 4.20085C19.1621 4.60938 19.416 5.17415 19.4176 5.79915H19.4209V5.80241V17.7279V17.7295H19.4176C19.416 18.3545 19.1621 18.9225 18.7503 19.3343C18.3418 19.7412 17.777 19.9951 17.152 19.9967V20H17.1488H7.10645H7.10482V19.9967C6.47982 19.9951 5.91016 19.7412 5.5 19.3294C5.0931 18.9209 4.83919 18.3561 4.83757 17.7311H4.83431V17.7279V15.057H2.85026H2.84863V15.0537C2.22363 15.0521 1.65397 14.7982 1.24382 14.3864C0.836914 13.9779 0.583008 13.4131 0.58138 12.7881H0.578125V12.7848V2.27214V2.27051H0.58138C0.583008 1.64388 0.838542 1.07585 1.2487 0.66569C1.65723 0.258789 2.22201 0.00488281 2.84701 0.00325521V0H2.85026H12.8926H12.8942V0.00325521C13.5208 0.00488281 14.0889 0.258789 14.499 0.670573C14.9059 1.0791 15.1598 1.64388 15.1615 2.26888H15.1647V2.27214ZM13.4427 3.53027V2.27214V2.26888H13.446C13.446 2.12077 13.3825 1.98405 13.2816 1.88314C13.1823 1.78385 13.0439 1.72038 12.8958 1.72038V1.72363H12.8942H2.85189H2.84863V1.72038C2.70052 1.72038 2.5638 1.78385 2.46289 1.88477C2.36361 1.98405 2.30013 2.1224 2.30013 2.27051H2.30339V2.27214V12.7848V12.7881H2.30013C2.30013 12.9362 2.36361 13.0729 2.46452 13.1738C2.5638 13.2731 2.70215 13.3366 2.85026 13.3366V13.3333H2.85189H4.83594V5.80241V5.80078H4.83919C4.84082 5.17415 5.09635 4.60612 5.50651 4.19596C5.91504 3.78906 6.47982 3.53516 7.10482 3.53353V3.53027H7.10807H13.4427ZM17.6973 17.7279V5.80241V5.79915H17.7005C17.7005 5.65104 17.637 5.51432 17.5361 5.41341C17.4368 5.31413 17.2985 5.25065 17.1504 5.25065V5.25391H17.1488H7.10645H7.10319V5.25065C6.95508 5.25065 6.81836 5.31413 6.71745 5.41504C6.61816 5.51432 6.55469 5.65267 6.55469 5.80078H6.55794V5.80241V17.7279V17.7311H6.55469C6.55469 17.8792 6.61816 18.016 6.71908 18.1169C6.81836 18.2161 6.95671 18.2796 7.10482 18.2796V18.2764H7.10645H17.1488H17.152V18.2796C17.3001 18.2796 17.4368 18.2161 17.5378 18.1152C17.637 18.016 17.7005 17.8776 17.7005 17.7295H17.6973V17.7279Z"
                        fill="#FF901A"
                      />
                    </svg>
                  </InputAdornment>
                ),
              }}
            />
          </div>

          <div className="otp_flx mt-20 mb-20">
            <span className="otp">Share To </span>
          </div>

          <div className="display-3 social-flx">
            <a href="#">
              <img src={whatsapp} alt="img" />
            </a>
            <a href="#">
              <img src={telegram1} alt="img" />
            </a>
            <a href="#">
              <img src={linkedin1} alt="img" />
            </a>
            <a href="#">
              <img src={facebook1} alt="img" />
            </a>
            <a href="#">
              <img src={instagram1} alt="img" />
            </a>
            <a href="#">
              <img src={x1} alt="img" />
            </a>
          </div>
        </Box>
      </Modal>

      <Modal
        open={openearn}
        onClose={handleCloseearn}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box class="boxstyle">
          <Typography id="modal-modal-title" variant="h6" component="h2">
            <div className="otp_flx">
              <span className="otp"> </span>
              <svg
                onClick={handleCloseearn}
                className="cursor-pointer fill_dark_to_white"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_37_40168)">
                  <path
                    d="M18.75 5.25L5.25 18.75"
                    stroke="black"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M18.75 18.75L5.25 5.25"
                    stroke="black"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_37_40168">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </Typography>
          <br />

          <label className="lab_l">Earned Rewards</label>
          <div className="input_box">
            <TextField
              fullWidth
              value={"1.0"}
              sx={{
                borderRadius: "5px",
                "& .MuiInputBase-formControl": {
                  borderRadius: "5px",
                  backgroundColor: "#fafafa",
                },
                "& .MuiInputBase-input": {
                  padding: "11px  0 11px 20px",
                  border: "0",
                },
                "& fieldset": { border: "0px solid #d3d1d1 !important" },
                "& .MuiInputBase-input::placeholder": {
                  color: "black",
                  fontSize: "15px",
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">USDT</InputAdornment>
                ),
              }}
            />
          </div>
          <div className="sub_txt mb-20">1 Dreamster-Exchange = 0007 USDT</div>

          <label className="lab_l">Receive Dreamster-Exchange</label>
          <div className="input_box">
            <TextField
              fullWidth
              value={"500"}
              sx={{
                borderRadius: "5px",
                "& .MuiInputBase-formControl": {
                  borderRadius: "5px",
                  backgroundColor: "#fafafa",
                },
                "& .MuiInputBase-input": {
                  padding: "11px  0 11px 20px",
                  border: "0",
                },
                "& fieldset": { border: "0px solid #d3d1d1 !important" },
                "& .MuiInputBase-input::placeholder": {
                  color: "black",
                  fontSize: "15px",
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    Dreamster-Exchange
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <div className="note_org mt-20 mb-20">
            Note: The USDT amount converted to Dreamster-Exchange has been
            deposited in the spot wallet.
          </div>
          <Button
            onClick={handleopenearn}
            className="org_btn radius"
            style={{ width: "100%", padding: "10px 20px", fontSize: "14px" }}
          >
            Claim
          </Button>
        </Box>
      </Modal>

      <Modal
        open={openrefferal}
        onClose={handleCloserefferal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box class="boxstyle">
          <Typography id="modal-modal-title" variant="h6" component="h2">
            <div className="otp_flx">
              <span className="otp"> </span>
              <svg
                onClick={handleCloserefferal}
                className="cursor-pointer fill_dark_to_white"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_37_40168)">
                  <path
                    d="M18.75 5.25L5.25 18.75"
                    stroke="black"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M18.75 18.75L5.25 5.25"
                    stroke="black"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_37_40168">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </Typography>
          <br />

          <label className="lab_l">Referral Rewards</label>
          <div className="input_box">
            <TextField
              fullWidth
              value={"1.0"}
              sx={{
                borderRadius: "5px",
                "& .MuiInputBase-formControl": {
                  borderRadius: "5px",
                  backgroundColor: "#fafafa",
                },
                "& .MuiInputBase-input": {
                  padding: "11px  0 11px 20px",
                  border: "0",
                },
                "& fieldset": { border: "0px solid #d3d1d1 !important" },
                "& .MuiInputBase-input::placeholder": {
                  color: "black",
                  fontSize: "15px",
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">USDT</InputAdornment>
                ),
              }}
            />
          </div>
          <div className="sub_txt mb-20">1 Dreamster-Exchange = 0007 USDT</div>

          <label className="lab_l">Receive Dreamster-Exchange</label>
          <div className="input_box">
            <TextField
              fullWidth
              value={"500"}
              sx={{
                borderRadius: "5px",
                "& .MuiInputBase-formControl": {
                  borderRadius: "5px",
                  backgroundColor: "#fafafa",
                },
                "& .MuiInputBase-input": {
                  padding: "11px  0 11px 20px",
                  border: "0",
                },
                "& fieldset": { border: "0px solid #d3d1d1 !important" },
                "& .MuiInputBase-input::placeholder": {
                  color: "black",
                  fontSize: "15px",
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    Dreamster-Exchange
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <div className="note_org mt-20 mb-20">
            Note: The USDT amount converted to Dreamster-Exchange has been
            deposited in the spot wallet.
          </div>
          <Button
            onClick={handleopenearn}
            className="org_btn radius"
            style={{ width: "100%", padding: "10px 20px", fontSize: "14px" }}
          >
            Claim
          </Button>
        </Box>
      </Modal>
    </>
  );
}
